module.exports = __webpack_public_path__ + "img/icon-mastercard.84675498.svg";